import {
  ApprovalStatsSummary,
  ApprovalTableRow,
  HistoryStatusFilter,
  JobsTabKey,
  SuperAdminPendingApprovalJobs,
} from "../model/super_admin_jobs_model";

export type SuperAdminJobsPendingApprovalsAction =
  | {
      type: "SET_PENDING_APPROVALS";
      payload: SuperAdminPendingApprovalJobs[];
    }
  | { type: "SET_PENDING_CURRENT_PAGE"; payload: number }
  | { type: "SET_PENDING_ROWS_PER_PAGE"; payload: number }
  | { type: "SET_PENDING_TOTAL_COUNT"; payload: number }
  | { type: "SET_PENDING_LOADING"; payload: boolean }
  | { type: "SET_PENDING_ERROR"; payload: string | null }
  | {
      type: "SET_APPROVAL_HISTORY";
      payload: ApprovalTableRow[];
    }
  | { type: "SET_OPEN_MENU"; payload: string | null }
  | { type: "SET_ACTIVE_TAB"; payload: JobsTabKey }
  | { type: "SET_HISTORY_STATUS_FILTER"; payload: HistoryStatusFilter }
  | { type: "SET_HISTORY_SEARCH_TERM"; payload: string }
  | { type: "CLEAR_HISTORY_FILTERS" }
  | { type: "SET_CURRENT_PAGE"; payload: number }
  | { type: "SET_ROWS_PER_PAGE"; payload: number }
  | { type: "SET_HISTORY_TOTAL_COUNT"; payload: number }
  | { type: "SET_HISTORY_LOADING"; payload: boolean }
  | { type: "SET_HISTORY_ERROR"; payload: string | null }
  | { type: "SET_APPROVAL_STATS"; payload: ApprovalStatsSummary };

export const setPendingApprovals = (
  payload: SuperAdminPendingApprovalJobs[]
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_PENDING_APPROVALS",
  payload,
});

export const setPendingCurrentPage = (
  payload: number
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_PENDING_CURRENT_PAGE",
  payload,
});

export const setPendingRowsPerPage = (
  payload: number
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_PENDING_ROWS_PER_PAGE",
  payload,
});

export const setPendingTotalCount = (
  payload: number
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_PENDING_TOTAL_COUNT",
  payload,
});

export const setPendingLoading = (
  payload: boolean
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_PENDING_LOADING",
  payload,
});

export const setPendingError = (
  payload: string | null
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_PENDING_ERROR",
  payload,
});

export const setApprovalHistory = (
  payload: ApprovalTableRow[]
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_APPROVAL_HISTORY",
  payload,
});

export const setOpenMenu = (
  payload: string | null
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_OPEN_MENU",
  payload,
});

export const setActiveTab = (
  payload: JobsTabKey
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_ACTIVE_TAB",
  payload,
});

export const setHistoryStatusFilter = (
  payload: HistoryStatusFilter
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_HISTORY_STATUS_FILTER",
  payload,
});

export const setHistorySearchTerm = (
  payload: string
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_HISTORY_SEARCH_TERM",
  payload,
});

export const clearHistoryFilters =
  (): SuperAdminJobsPendingApprovalsAction => ({
    type: "CLEAR_HISTORY_FILTERS",
  });

export const setCurrentPage = (
  payload: number
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_CURRENT_PAGE",
  payload,
});

export const setRowsPerPage = (
  payload: number
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_ROWS_PER_PAGE",
  payload,
});

export const setHistoryTotalCount = (
  payload: number
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_HISTORY_TOTAL_COUNT",
  payload,
});

export const setHistoryLoading = (
  payload: boolean
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_HISTORY_LOADING",
  payload,
});

export const setHistoryError = (
  payload: string | null
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_HISTORY_ERROR",
  payload,
});

export const setApprovalStats = (
  payload: ApprovalStatsSummary
): SuperAdminJobsPendingApprovalsAction => ({
  type: "SET_APPROVAL_STATS",
  payload,
});
